var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512px",
    height: "512px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.997
    },
    fill: "#ff4d12",
    d: "M 156.5,-0.5 C 189.833,-0.5 223.167,-0.5 256.5,-0.5C 256.5,56.1667 256.5,112.833 256.5,169.5C 225.662,169.169 194.995,169.502 164.5,170.5C 162.5,170.5 160.5,170.5 158.5,170.5C 112.475,160.632 87.4751,132.132 83.5,85C 84.9228,50.463 100.589,24.7964 130.5,8C 138.991,4.22454 147.657,1.39121 156.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.995
    },
    fill: "#fe7261",
    d: "M 256.5,-0.5 C 288.833,-0.5 321.167,-0.5 353.5,-0.5C 398.379,10.2279 422.713,38.7279 426.5,85C 422.394,132.595 397.061,161.095 350.5,170.5C 342.5,170.5 334.5,170.5 326.5,170.5C 303.167,170.5 279.833,170.5 256.5,170.5C 225.833,170.5 195.167,170.5 164.5,170.5C 194.995,169.502 225.662,169.169 256.5,169.5C 256.5,112.833 256.5,56.1667 256.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.997
    },
    fill: "#b559ff",
    d: "M 158.5,170.5 C 160.5,170.5 162.5,170.5 164.5,170.5C 195.167,170.5 225.833,170.5 256.5,170.5C 256.5,193.5 256.5,216.5 256.5,239.5C 256.5,250.167 256.5,260.833 256.5,271.5C 256.5,294.5 256.5,317.5 256.5,340.5C 224.5,340.5 192.5,340.5 160.5,340.5C 113.419,331.746 88.0852,303.413 84.5,255.5C 88.0599,208.675 112.727,180.342 158.5,170.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.992
    },
    fill: "#00bcff",
    d: "M 326.5,170.5 C 334.5,170.5 342.5,170.5 350.5,170.5C 383.768,174.603 407.268,191.937 421,222.5C 435.318,266.543 423.818,302.043 386.5,329C 351.658,347.416 318.325,345.083 286.5,322C 270.956,308.404 260.956,291.571 256.5,271.5C 256.5,260.833 256.5,250.167 256.5,239.5C 265.944,202.389 289.278,179.389 326.5,170.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.996
    },
    fill: "#01ce7f",
    d: "M 160.5,340.5 C 192.5,340.5 224.5,340.5 256.5,340.5C 256.667,372.502 256.5,404.502 256,436.5C 248.648,477.349 224.815,502.349 184.5,511.5C 175.5,511.5 166.5,511.5 157.5,511.5C 112.617,500.768 88.2832,472.268 84.5,426C 88.6056,378.405 113.939,349.905 160.5,340.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.1d8b699b605a0f03c42c0dd939fe842b.svg";
export { ForwardRef as ReactComponent };